import React from "react";
import TextField from "../../../bootstrap/TextField";
import {
  FirstNameAndNid,
  Passenger,
  Select,
  UserContactWrapper,
} from "../SingleTravellerInformation/singleTravellerInformation.styles";

const ReturnTravellerInformation = ({
  values,
  passengerIndex,
  handleChange,
  roundTrip,
}) => {
  return (
    <div>
      <>
        <Passenger>
          {roundTrip ? (
            <label htmlFor={`rname${passengerIndex ? passengerIndex : ""}`}>
              Passenger {passengerIndex}
            </label>
          ) : (
            <label htmlFor={`name${passengerIndex ? passengerIndex : ""}`}>
              Passenger {passengerIndex}
            </label>
          )}

          {roundTrip ? (
            <UserContactWrapper>
              <FirstNameAndNid>

                <TextField
                  id={`first${passengerIndex}`}
                  name={`first${passengerIndex}`}
                  type="text"
                  placeholder="First Name"
                  value={values[`first${passengerIndex}`]}
                  onChange={handleChange}
                  autoComplete="nope"
                />
              </FirstNameAndNid>
              <TextField
                type="text"
                placeholder="Surname"
                name={`second${passengerIndex}`}
                value={values[`second${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </UserContactWrapper>
          ) : (
            <UserContactWrapper>
              <FirstNameAndNid>

                <TextField
                  id={`first${passengerIndex}`}
                  name={`first${passengerIndex}`}
                  type="text"
                  placeholder="First Name"
                  value={values[`first${passengerIndex}`]}
                  onChange={handleChange}
                  autoComplete="nope"
                />
              </FirstNameAndNid>
              <TextField
                type="text"
                placeholder="Surname"
                name={`second${passengerIndex}`}
                value={values[`second${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </UserContactWrapper>
          )}
        </Passenger>
        {/* end passenger */}

        {roundTrip ? (
          <Passenger>
            <label htmlFor={`renid${passengerIndex ? passengerIndex : ""}`}>
              National ID
            </label>
            <UserContactWrapper>
              {/* start */}
              <FirstNameAndNid>
                <TextField
                  id={`renid${passengerIndex ? passengerIndex : ""}`}
                  name={`renid${passengerIndex}`}
                  type="text"
                  placeholder="National ID number"
                  value={values[`renid${passengerIndex}`]}
                  onChange={handleChange}
                />
              </FirstNameAndNid>

              <TextField
                type="number"
                placeholder="Contact No"
                name={`contactNo${passengerIndex}`}
                maxLength="10"
                value={values[`contactNo${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </UserContactWrapper>
          </Passenger>
        ) : (
          <Passenger>
            <label htmlFor={`renid${passengerIndex ? passengerIndex : ""}`}>
              National ID
            </label>
            <UserContactWrapper>
              {/* start */}
              <FirstNameAndNid>
                <TextField
                  id={`renid${passengerIndex ? passengerIndex : ""}`}
                  name={`renid${passengerIndex}`}
                  type="text"
                  placeholder="National ID number"
                  value={values[`renid${passengerIndex}`]}
                  onChange={handleChange}
                />
              </FirstNameAndNid>

              <TextField
                type="number"
                placeholder="Contact No"
                name={`contactNo${passengerIndex}`}
                maxLength="10"
                value={values[`contactNo${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </UserContactWrapper>
          </Passenger>
        )}
      </>
    </div>
  );
};

export default ReturnTravellerInformation;
